import { render } from "./AuthTos.vue?vue&type=template&id=3e28b7ba"
import script from "./AuthTos.vue?vue&type=script&lang=js"
export * from "./AuthTos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__